import * as React from "react";
import type { SVGProps } from "react";
const SvgWiFiOff = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="m5.1 3.235-.1-.1L3.586 4.55l.707.707.756.756a13 13 0 0 0-2.357 1.911l-.698.716 1.432 1.396.698-.716a11 11 0 0 1 2.38-1.851l1.477 1.476a9 9 0 0 0-2.623 1.982l-.675.738 1.476 1.35.675-.738a7 7 0 0 1 2.663-1.816l1.617 1.617a5 5 0 0 0-3.061 1.852l-.615.789 1.578 1.229.615-.79A3 3 0 0 1 12 14c.49 0 .953.117 1.362.326l1.618 1.618.003.004 1.81 1.81.707.706 1.38-1.38a1 1 0 0 1-.087-.077l-13.5-13.5a1 1 0 0 1-.194-.272m10.524 7.774a7 7 0 0 1 1.543 1.268l.675.738 1.476-1.35-.675-.738a8.98 8.98 0 0 0-6.007-2.905zM10.69 6.077Q11.336 6 12 6c3.087 0 5.876 1.27 7.875 3.32l.698.716 1.432-1.396-.698-.716A12.96 12.96 0 0 0 12 4c-1.043 0-2.058.123-3.03.355zM14 18a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
            clipRule="evenodd"
        />
    </svg>
);
export default SvgWiFiOff;
